import React from 'react';
import '../../resources/styles/loader.scss';

const ThreeDotsLoader = ({ className }) => {
    return (
        <div className={`three-dots-loader ${className}`}>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};

export default ThreeDotsLoader;
